<template>
<div class='t-button-group'>
<slot></slot>
</div>
</template>

<script>
export default {
  name: 't-button-group'
}
</script>